import React from "react";
import { Container } from "reactstrap";

import classes from "@/styles/generic/help.module.css";
import { help } from "@/utils/content";
import CollectionCards from "./collection-cards";

type Props = {};

const HelpMain = ({}: Props) => {
  const content = help.en;

  return (
    <main className={classes.main}>
      <Container>
        <h1 className={classes.heading}>{content.title}</h1>
      </Container>
      <CollectionCards showContactUs />
    </main>
  );
};

export default HelpMain;
